import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AsyncAction } from 'rxjs/internal/scheduler/AsyncAction';
import { AsyncService } from '../../core/async/async.service';
import { DaoService } from '../../core/dao/dao.service';
import { IUser } from '../../core/models/acustica-user.model';
import { IAudioPlugin } from '../../core/models/plugin.model';
import { ITaskSettings } from '../../core/models/task-settings.model';
import { TaskModel } from '../task/task.model';
import { faRecycle } from "@fortawesome/free-solid-svg-icons"

@Component({
  selector: 'app-admin',
  templateUrl: 'admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements AfterViewInit {
  public plugins: IAudioPlugin[] = [];
  public usersDataSource: IUser[] = [];
  public userColumns: any[] = [];
  public emailConfigurationDataSource: any = [];
  public emailConfigurationColumns: any[] = [];
  public taskSettingsDataSource: ITaskSettings[] = [];
  public taskSettingsColumns: any[] = [];
  public pluginsDataSource: IAudioPlugin[] = [];
  public pluginsColumns: any[] = [];
  faRecycle = faRecycle;

  constructor(
    private dao: DaoService,
    public taskModel: TaskModel,
    private async: AsyncService,
    private toastr: ToastrService,
    private loader: NgxUiLoaderService
  ) {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initUsersGrid();
      this.initEmailSettingsGrid();
      this.initTaskSettingsGrid();
      this.initPluginsGrid();
      this.refreshData();
    }, 0)
  }

  //Task Settings
  initTaskSettingsGrid() {
    this.taskSettingsColumns = [
      {
        dataField: "consumptionMode",
        caption: "Consumption Mode (0 - Size, 1 - Time)",
        allowEditing: true
      },
      {
        dataField: "defaultComputingUnits",
        caption: "Default Computing Units",
        allowEditing: true
      }
    ]
  }

  getTaskSettings() {
    return new Promise((resolve, reject) => {
      this.dao.GetTaskSettings().subscribe(result => {
        this.taskSettingsDataSource = [result];
        resolve(result);
      }, error => {
        reject(error);
      })
    })
  }

  onTaskSettingsGridSaving(event: any) {
    this.async.openDialog("Update Users", "This operation will update the task settings' data, do you wish to continue?", (result) => {
      if (result) {
        let taskSettings: any[] = this.getChanges(event);
        this.loader.start();
        event.promise = new Promise((resolve, reject) => {
          this.dao.SetTaskSettings(taskSettings[0])
            .subscribe(result => {
              this.loader.stop();
              event.component.refresh(true);
              event.component.cancelEditData();
              resolve(taskSettings);
            }, error => {
              this.loader.stop();
              event.component.refresh(true);
              event.component.cancelEditData();
              resolve(null);
              this.toastr.error(error, "Error");
            });
        })
      }
      else
        this.refreshData();
    })
  }

  //Email Settings
  initEmailSettingsGrid() {
    this.emailConfigurationColumns = [
      {
        dataField: "sender",
        caption: "Sender",
        allowEditing: true
      },
      {
        dataField: "smtpAddress",
        caption: "Smpt Addres",
        allowEditing: true
      },
      {
        dataField: "smtpPort",
        caption: "Smpt Port",
        allowEditing: true
      },
      {
        dataField: "username",
        caption: "Username",
        allowEditing: true
      },
      {
        dataField: "subject",
        caption: "Subject",
        allowEditing: true
      },
      {
        dataField: "password",
        caption: "Password",
        allowEditing: true
      },
      //{
      //  dataField: "tempalte",
      //  caption: "Template",
      //  allowEditing: true
      //},
      {
        dataField: "enableSsl",
        caption: "Enable SSL",
        allowEditing: true
      }
    ]
  }

  getEmailSettings() {
    return new Promise((resolve, reject) => {
      this.dao.GetEmailSettings().subscribe(result => {
        this.emailConfigurationDataSource = [result];
        resolve(result);
      }, error => {
        reject(error);
      })
    })
  }

  onEmailSettingsGridSaving(event: any) {
    this.async.openDialog("Update Users", "This operation will update the email settings' data, do you wish to continue?", (result) => {
      if (result) {
        let emailSettings: any[] = this.getChanges(event);
        this.loader.start();
        event.promise = new Promise((resolve, reject) => {
          this.dao.SetEmailSettings(emailSettings[0])
            .subscribe(result => {
              this.loader.stop();
              event.component.refresh(true);
              event.component.cancelEditData();
              resolve(emailSettings);
            }, error => {
              this.loader.stop();
              event.component.refresh(true);
              event.component.cancelEditData();
              resolve(null);
              this.toastr.error(error, "Error");
            });
        })
      }
      else
        this.refreshData();
    })
  }

  //User Settings
  onUsersGridReady(event: any) {

  }

  getUsers() {
    return this.dao.GetUsers().subscribe(users => {
      this.usersDataSource = users;
    }, error => {
      this.toastr.error(error, "Get Users Error");
    })
  }

  initUsersGrid() {
    this.userColumns = [
      {
        dataField: "email",
        caption: "Email",
        allowEditing: true
      },
      {
        dataField: "name",
        caption: "Name",
        allowEditing: true
      },
      {
        dataField: "computingUnits",
        caption: "Computing Units",
        allowEditing: true
      },
      {
        dataField: "computingUnitsExtra",
        caption: "Computing Units Extra",
        allowEditing: true
      },
      {
        dataField: "enableEmailNotifications",
        caption: "Enable Email Notifications",
        allowEditing: true
      }
    ]
    this.getUsers();
  }

  onUserGridSaving(event: any) {
    this.async.openDialog("Update Users", "This operation will update the user's data, do you wish to continue?", (result) => {
      if (result) {
        let users: any[] = this.getChanges(event);

        this.loader.start();
        event.promise = new Promise((resolve, reject) => {
          this.dao.SetUsers(users)
            .subscribe(result => {
              this.loader.stop();
              event.component.refresh(true);
              event.component.cancelEditData();
              resolve(users);
            }, error => {
              this.loader.stop();
              event.component.refresh(true);
              event.component.cancelEditData();
              resolve(null);
              this.toastr.error(error, "Error");
            });
        })
      }
      else
        this.refreshData();
    })
  }

  //Plugins
  onPluginsGridReady(event: any) {

  }

  getPlugins() {
    return this.dao.GetPlugins().subscribe(plugins => {
      this.pluginsDataSource = plugins;
    }, error => {
      this.toastr.error(error, "Get Plugins Error");
    })
  }

  initPluginsGrid() {
    this.pluginsColumns = [
      {
        dataField: "name",
        caption: "Name",
        allowEditing: true,
      },
      {
        dataField: "path",
        caption: "Path",
        allowEditing: true,
      },
      {
        dataField: "thumbnail",
        caption: "Thumbnail",
        allowEditing: true,
        width: 150
      },
      {
        dataField: "caption",
        caption: "Caption",
        allowEditing: true,
      },
      {
        dataField: "description",
        caption: "Description",
        allowEditing: true,
        width: 150
      },
      {
        dataField: "logo",
        caption: "Logo",
        allowEditing: true,
        width: 150
      },
      {
        dataField: "computingUnitsMultiplier",
        caption: "Computing Units Multiplier",
        allowEditing: true,
      },
      //{
      //  dataField: "menuItems",
      //  caption: "Menu Items",
      //  allowEditing: true
      //}
    ]
    this.getUsers();
  }

  onPluginsGridSaving(event: any) {
    this.async.openDialog("Update Plugins", "This operation will update the plugins' data, do you wish to continue?", (result) => {
      if (result) {
        //let data: any[] = this.getChanges(event);

        this.loader.start();
        event.promise = new Promise((resolve, reject) => {
          this.dao.SetPlugins(this.pluginsDataSource)
            .subscribe(data => {
              this.loader.stop();
              event.component.refresh(true);
              event.component.cancelEditData();
              resolve(data);
            }, error => {
              this.loader.stop();
              event.component.refresh(true);
              event.component.cancelEditData();
              resolve(null);
              this.toastr.error(error, "Error");
            });
        })
      }
      else
        this.refreshData();
    })
  }
  //Global

  getChanges(event: any) {
    let toReturn: any[] = [];
    let changes = event.changes;
    for (let c in changes) {
      let change = changes[c];
      let data = change.key;
      let newData = change.data;
      let keys = Object.keys(data);
      for (let k in keys) {
        let key = keys[k];
        if (newData[key]) {
          data[key] = newData[key];
        }
      }
      toReturn.push(data);
    }
    return toReturn;
  }

  refreshData() {
    this.loader.start();
    return Promise.all([
      this.getEmailSettings(),
      this.getTaskSettings(),
      this.getUsers(),
      this.getPlugins()
    ]).then(
      result => {
        this.loader.stop();
        window.dispatchEvent(new Event('resize'));
      }, error => {
        this.loader.stop();
      })
  }
}
